import { test } from 'last-validator'

export const isMinLength = (min: number) => test(
    (value: string) => (value?.trim() || '').length >= min,
    `Minimálny počet znakov je ${min}.`
)
